// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type ConnectFastlyToSiteMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  config: Types.FastlyConnectionInput;
}>;


export type ConnectFastlyToSiteMutation = (
  { __typename?: 'Mutation' }
  & { connectFastlyToSite?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message' | 'errorType'>
  )> }
);


export const ConnectFastlyToSiteDocument = gql`
    mutation ConnectFastlyToSite($siteId: UUID!, $config: FastlyConnectionInput!) {
  connectFastlyToSite(siteId: $siteId, config: $config) {
    success
    message
    errorType
  }
}
    `;
export type ConnectFastlyToSiteMutationFn = ApolloReactCommon.MutationFunction<ConnectFastlyToSiteMutation, ConnectFastlyToSiteMutationVariables>;

/**
 * __useConnectFastlyToSiteMutation__
 *
 * To run a mutation, you first call `useConnectFastlyToSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectFastlyToSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectFastlyToSiteMutation, { data, loading, error }] = useConnectFastlyToSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useConnectFastlyToSiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConnectFastlyToSiteMutation, ConnectFastlyToSiteMutationVariables>) {
        return ApolloReactHooks.useMutation<ConnectFastlyToSiteMutation, ConnectFastlyToSiteMutationVariables>(ConnectFastlyToSiteDocument, baseOptions);
      }
export type ConnectFastlyToSiteMutationHookResult = ReturnType<typeof useConnectFastlyToSiteMutation>;
export type ConnectFastlyToSiteMutationResult = ApolloReactCommon.MutationResult<ConnectFastlyToSiteMutation>;
export type ConnectFastlyToSiteMutationOptions = ApolloReactCommon.BaseMutationOptions<ConnectFastlyToSiteMutation, ConnectFastlyToSiteMutationVariables>;
